
function Header({setAuthToken, appUserName, setAppUserName}) {

  function UserLogout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    setAuthToken(null);
    setAppUserName(null);
  }

  return(
    <nav className="navbar navbar-dark bg-opacity-75 bg-gradient fixed-top fsvok2" >
      <div className="container-fluid px-5">
        <a className="navbar-brand lk-navbar-link" href="/">ФСВОК | кабинет юриста</a>
        <div className="">
          <span className="navbar-text ml-5"> Пользователь: {appUserName} <button className="mx-1 lk-button lk-nav-button" onClick={UserLogout}>Выход</button></span>
        </div>
      </div>
    </nav>
  );
}

export default Header